/*  MUI  */
import { Box, Skeleton, TablePagination } from '@mui/material';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/* Internal Components */
import { useManagedTableV2Context } from '../ManagedTableV2ContextProvider';

const muiFixedRowsPerPageOptions = [2, 5, 10, 25, 50, 100];

export const ManagedTablePaginationV2 = ({ disabled }) => {
    const { t } = useTranslation();
    const { apiTable, table } = useManagedTableV2Context();

    const count = table.getFilteredRowModel().rows.length;

    // Ensure page index is valid. Tanstack pagination state is not updated when the table is already filtered.
    const currentPageIndex = Math.min(
        table.getState().pagination.pageIndex,
        Math.max(table.getPageCount() - 1, 0)
    );

    const rowsPerPageOptions = [
        ...muiFixedRowsPerPageOptions,
        {
            label: t('Common.all'),
            value: count
        }
    ];

    const rowsPerPage = muiFixedRowsPerPageOptions.includes(
        table.getState().pagination.pageSize
    )
        ? table.getState().pagination.pageSize
        : count;

    return apiTable && disabled ? (
        <Box width="33%">
            <Skeleton height="32px" animation="wave" />
        </Box>
    ) : (
        <TablePagination
            component="div"
            count={count}
            data-testid="managedTableTablePagination"
            disabled={false}
            labelRowsPerPage={`${t('Table.rowsPerPage')}:`}
            onPageChange={(event, page) => table.setPageIndex(page)}
            onRowsPerPageChange={(e) => {
                const size = e.target.value ? Number(e.target.value) : 10;
                table.setPageSize(size);
            }}
            page={currentPageIndex}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={rowsPerPageOptions}
            showFirstButton
            showLastButton
            slotProps={{
                select: { inputProps: { 'aria-label': 'rows per page' } }
            }}
        />
    );
};
